module.exports = __webpack_public_path__ + "img/scene-game.dd8fb04f.png";